const TAB_CLASS = "tabset__tab";
const TAB_CONTENT_CLASS = "tabset__tab-content";
const ACTIVE_CLASS = "-active";
const TAB_CONTENT_ATTR = "data-tab-content";

document.addEventListener("DOMContentLoaded", init);

export default function init() {
  for (const tab of tabs()) {
    tab.addEventListener("click", clickTab.bind(tab));
    if (active(tab)) {
      pushState(tab, true);
    }
  }
}

function tabs() {
  return document.querySelectorAll(`.${TAB_CLASS}[${TAB_CONTENT_ATTR}]`);
}

function clickTab(e) {
  e.preventDefault();
  if (!active(this)) {
    activateTab(this);
    pushState(this);
  }
}

function active(tab) {
  return tab.classList.contains(ACTIVE_CLASS);
}

function activateTab(theTab) {
  for (const tab of tabs()) {
    const tabContentId = tab.getAttribute(TAB_CONTENT_ATTR);
    const tabContent = document.getElementById(tabContentId);
    if (tab === theTab) {
      tab.className = `${TAB_CLASS} ${ACTIVE_CLASS}`;
      tabContent.className = `${TAB_CONTENT_CLASS} ${ACTIVE_CLASS}`;
    } else {
      tab.className = TAB_CLASS;
      tabContent.className = TAB_CONTENT_CLASS;
    }
  }
}

function pushState(tab, replace = false) {
  const todo = replace ? history.replaceState : history.push;

  const tabUrl = tab.getElementsByTagName("a")[0].href;
  const tabContentId = tab.getAttribute(TAB_CONTENT_ATTR);
  if (replace) {
    history.replaceState(tabContentId, tab.textContent, tabUrl);
  } else {
    history.pushState(tabContentId, tab.textContent, tabUrl);
  }
}

window.onpopstate = function(e) {
  const tabContentId = e.state;
  if (tabContentId === null) return;

  const tab = document.querySelector(
    `.${TAB_CLASS}[${TAB_CONTENT_ATTR}=${tabContentId}]`,
  );
  if (tab === null) return;

  activateTab(tab);
};
